import ImageHelper, {
  Container as ImageHelperContainer,
} from "@components/ImageHelper"
import Scrollbar from "@components/Scrollbar"
import animation, { cubicBezier } from "@constants/animation"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import _ from "lodash-es"
import React from "react"
import styled from "styled-components"

const Container = styled.div`
  flex-direction: row;
  flex-wrap: nowrap;
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  background-color: ${colors.white};

  @media ${breakpoints.mobileOnly} {
    margin-bottom: -20px;
    padding: 20px 20px 40px;
  }

  @media ${breakpoints.laptop} {
    width: calc(7 / 12 * 100vw);
    padding: 24px 32px 0;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`

const Item = styled.div`
  display: inline-flex;
  flex-direction: row;
`

const ImageWrapper = styled.div`
  position: relative;
  width: 136px;
  height: 136px;
  margin: 0;
  padding: 0;
  transition: background-color ${animation.quick} ${cubicBezier};
  background-color: ${colors.reviewGray};

  @media ${breakpoints.laptop} {
    &:hover {
      background-color: ${colors.reviewGrayHover};
      cursor: pointer;
    }
  }

  ${ImageHelperContainer} {
    flex-grow: 0;
    flex-shrink: 0;
    width: 100%;
    height: auto;

    img {
      object-fit: contain;
    }
  }
`

const ItemOverlay = styled.div<{ show: boolean }>`
  position: absolute;
  top: 0;
  display: ${({ show }) => (show ? "initial" : "none")};
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.65);
`

const Spacer = styled.div`
  width: 8px;
  height: 136px;
  background: transparent;

  @media ${breakpoints.laptop} {
    width: 12px;
  }
`

const FinalSpacer = styled.div`
  width: 20px;
  height: 136px;
  background: transparent;

  @media ${breakpoints.laptop} {
    32px;
  }
`

const CustomScrollbar = styled(Scrollbar)`
  padding: 0 0 0 20px;
  background-color: ${colors.white};

  @media ${breakpoints.laptop} {
    padding: 24px 32px;
  }
`

const MobileSafariScrollbarHider = styled.div`
  width: 100%;
  height: 20px;
  background-color: ${colors.white};
  z-index: 10;
`

const Slider = (props: any) => {
  return (
    <>
      <Container ref={props.contentRef}>
        {props.images.map((image, index) => (
          <Item key={JSON.stringify(image)} onClick={image.onClick}>
            <ImageWrapper>
              <ImageHelper
                alt={image.alt || ""}
                src={image.thumbnail || image.image}
              />
              <ItemOverlay show={props.currentImage === image.id} />
            </ImageWrapper>
            {index === props.images.length - 1 ? <FinalSpacer /> : <Spacer />}
          </Item>
        ))}
      </Container>
      <CustomScrollbar containerRef={props.contentRef} showControlsOnMobile />
      <MobileSafariScrollbarHider />
    </>
  )
}

export default Slider
